import { useMutation } from '@tanstack/react-query';
import {
  publishFlowchartVersion,
  setActiveFlowchartVersion
} from '../../request/flowchart';

export function useFlowchartMutations() {
  const publishFlowchartMutation = useMutation({
    mutationFn: (flowchartVersionId) => publishFlowchartVersion(flowchartVersionId)
  });

  const setActiveFlowchartMutation = useMutation({
    mutationFn: (flowchartVersionId) => setActiveFlowchartVersion(flowchartVersionId)
  });

  return {
    publishFlowchartMutation,
    setActiveFlowchartMutation
  };
}
